import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Confetti = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="confetti"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 52 52"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M37.1589 34.9108L17.6179 15.777C16.0493 14.2411 13.4164 14.8548 12.6887 16.926L2.10399 47.0517C1.26411 49.4421 3.58247 51.7329 5.96267 50.8644L36.0883 39.8726C38.1618 39.1161 38.7359 36.455 37.1589 34.9108Z" />
      <path d="M35.934 28.4526C36.5289 29.0475 37.4934 29.0475 38.0883 28.4526C43.8193 22.7215 49.3998 24.4934 49.4555 24.5118C50.2536 24.7778 51.1164 24.3465 51.3824 23.5484C51.6486 22.7504 51.2171 21.8875 50.419 21.6214C50.1186 21.5214 42.9818 19.2504 35.9341 26.2982C35.3391 26.893 35.339 27.8577 35.934 28.4526Z" />
      <path d="M26.2393 16.6035C33.2873 9.55646 31.0155 2.41907 30.916 2.11846C30.6499 1.32023 29.7867 0.889627 28.9884 1.1557C28.1912 1.42178 27.7596 2.284 28.0257 3.08223C28.044 3.13809 29.8161 8.71862 24.0843 14.4494C23.4931 15.0406 23.4871 16.0045 24.0843 16.6035C24.6824 17.2014 25.646 17.1968 26.2393 16.6035Z" />
      <path d="M29.4708 19.8353C28.8759 20.4302 28.8759 21.3947 29.4708 21.9896C30.0603 22.5791 31.0181 22.5869 31.6161 21.9987C32.4031 21.6065 34.8457 23.0773 36.2032 21.7203C37.5461 20.3773 36.1193 17.9843 36.4757 17.1457C37.3154 16.7884 39.7075 18.2159 41.0504 16.8731C42.3936 15.5301 40.9667 13.1371 41.3231 12.2984C42.164 11.941 44.5548 13.3687 45.8977 12.0258C47.2408 10.6828 45.814 8.28985 46.1703 7.4511C47.0063 7.09555 49.4031 8.51998 50.7451 7.17842C52.102 5.82132 50.634 3.37432 51.0233 2.59142C51.6093 1.99589 51.6061 1.03811 51.0143 0.446142C50.4194 -0.148775 49.4549 -0.148775 48.8599 0.446142C47.6593 1.64684 47.8942 3.34192 48.1203 4.5538C46.9084 4.32763 45.2135 4.09273 44.0128 5.29333C42.8121 6.49403 43.047 8.18911 43.2731 9.40098C42.0613 9.17492 40.3661 8.93981 39.1655 10.1406C37.9648 11.3413 38.1998 13.0364 38.426 14.2483C37.2139 14.0221 35.5189 13.7871 34.3183 14.9878C33.1176 16.1885 33.3525 17.8836 33.5787 19.0955C32.3667 18.8695 30.6714 18.6346 29.4708 19.8353Z" />
      <path d="M38.0883 6.9092C38.6832 6.31429 38.6832 5.34981 38.0883 4.75489C37.4934 4.15997 36.5289 4.15997 35.934 4.75489C35.3391 5.34981 35.3391 6.31429 35.934 6.9092C36.5289 7.50412 37.4934 7.50412 38.0883 6.9092Z" />
      <path d="M47.7826 18.1271C48.624 18.1271 49.306 17.4451 49.306 16.6038C49.306 15.7624 48.624 15.0804 47.7826 15.0804C46.9413 15.0804 46.2593 15.7624 46.2593 16.6038C46.2593 17.4451 46.9413 18.1271 47.7826 18.1271Z" />
      <path d="M44.5509 30.607C43.956 31.2019 43.956 32.1663 44.5509 32.7613C45.1458 33.3562 46.1103 33.3562 46.7052 32.7613C47.3001 32.1663 47.3001 31.2019 46.7052 30.607C46.1104 30.012 45.1458 30.012 44.5509 30.607Z" />
      <path d="M23.0075 9.06351C23.6024 8.4686 23.6024 7.50412 23.0075 6.9092C22.4126 6.31428 21.4481 6.31428 20.8532 6.9092C20.2583 7.50401 20.2583 8.4686 20.8532 9.06351C21.4481 9.65843 22.4127 9.65843 23.0075 9.06351Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Confetti.defaultProps = {
  className: null,
};

Confetti.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Confetti;
